import React, { useState } from "react"
import styles from './AppFileInput.module.css'

export const AppFileInput = ({ register, field, accept }) => {
    const [fileName, setFileName] = useState('')
    const onChangeHandler = (e) => {
        setFileName(e.target.files[0].name)
    }

    return <div className={styles.container}>
        <input
            className={styles.hidden}
            id={field}
            {...register(field, {onChange: onChangeHandler})} type='file'
            accept={accept}
        />
        <label
            className={styles.inputLabel}
            htmlFor={field} />
        <span className={styles.fileName}>{fileName}</span>
    </div>
}